import { IAuth } from '../../core/interfaces/auth.interface';

export class AuthLoginAction {
  static readonly type = '[Auth] Login';
  constructor(public payload: IAuth) {}
}

export class AuthLogoutAction {
  static readonly type = 'LogoutAction';
  constructor() {}
}
